import { createFileRoute, redirect } from '@tanstack/react-router'
import { getPreferredLang } from '@/hooks/useLang'

export const Route = createFileRoute('/account')({
  beforeLoad: async () => {
    throw redirect({ to: '/$lang/account', params: { lang: await getPreferredLang() }, replace: true })
  },
})
